// IBKR labels describe the view only. Grouping never changes asset identity.
export function watchlistSections(rows, profiles = {}) {
  const groups = new Map()
  const groupedRows = rows.map(row => {
    const profile = profiles[row.originalCard?.symbol || row.symbol]
    const sector = String(profile?.sector || '').trim()
    const category = String(profile?.category || '').trim()
    const id = sector || category ? JSON.stringify([sector, category]) : 'unclassified'
    const label = sector || category ? `${sector || 'Unclassified'} — ${category || 'Unclassified'}` : 'Unclassified'
    if (!groups.has(id)) groups.set(id, { id, label })
    return { ...row, groupId: id }
  })
  return { rows: groupedRows, groups: [...groups.values()].sort((a, b) => {
    if (a.id === 'unclassified') return 1
    if (b.id === 'unclassified') return -1
    return a.label.localeCompare(b.label)
  }) }
}
